const ns_group = {
	dialog_add: {
		autocomplete_debtor: {
			placeholder: "Selecteer een debiteur",
		},
		autocomplete_ns_group: {
			helper_text: "Selecteer een Oxxa nameserver. Als deze niet bestaat, maak hem dan aan in Oxxa",
			placeholder: "Selecteer een Oxxa nameserver-groep",
		},
		description: "Link een custom nameserver-groep aan een debiteur",
		has_dns_support: "Deze nameserver-groep ondersteunt het bewerken van de DNS via het portal.",
		message_error:
			"Er is iets fout gegaan tijdens het toevoegen van de nameserver-groep aan de debiteur",
		message_success: "Nameserver-groep succesvol toegevoegd aan debiteur",
		title: "Custom nameserver-groep",
	},

	dialog_del: {
		alert_info:
			"Wanneer deze verwijderd wordt zullen nieuwe domeinen geregistreerd worden met de standaard Tuxis nameservers",
		description: "Weet je zeker dat je <strong>{{ns_group}}</strong> wilt verwijderen?",
		message_error:
			"Er is iets fout gegaan tijdens het verwijderen van de nameserver-groep aan de debiteur!",
		message_success:
			"Nameserver group <strong>{{ns_group}}</strong> succesvol verwijderd voor debiteur <strong>{{debtor_code}}</strong>!",
		title: "Nameserver-groep verwijderen",
	},
	dialog_edit: {
		delete_dns: "DNS van dit domein direct verwijderen",
		delete_dns_description:
			"Als je de DNS niet direct verwijderd, dan moet je zelf na 14 dagen en voor 21 dagen handmatig de DNS zone uit PowerDNS verwijderen.",
		description: "Wijzig de gelinkte nameserver-groep aan het domein",
		message_error:
			"Er is iets fout gegaan tijdens het wijzigen van de nameserver-groep van het domein",
		message_success: "Nameserver-groep succesvol gewijzigd van het domein",
	},
};

export default ns_group;
